import React from "react"
import './Button.scss'
import Icons from './Icons'

const setIcon = (icon) => {
    switch(icon) {
        case 'formulas': return Icons.formulas
        default: return false
    }
}
/**
 * added spread props
 * @param {*} props 
 * @returns 
 */
const Button = props =>{

    const { disabled=false } = props;
    return(
        <button className={`nova-btn ${props.variant? props.variant: '' }`} onClick={props.onClick} disabled={disabled}>
            <span className={`nova-btn-txt ${props.icon ? 'with-icon' : ''}`}>
                { props.text } {props.icon && setIcon(props.icon)}
            </span>
        </button>
    )
}

export default Button;